import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";

export const PageHeader = ({ eyebrow, title, accent, intro, breadcrumbs = [] }) => {
    return (
        <section className="relative pt-32 pb-10 overflow-hidden" data-testid="page-header">
            <div className="absolute inset-0 -z-10">
                <div className="aurora opacity-60" />
                <div className="absolute inset-0 grid-bg opacity-30" />
            </div>

            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                {breadcrumbs.length > 0 && (
                    <motion.div
                        initial={{ opacity: 0, y: 6 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                        className="flex items-center gap-2 mb-5 font-mono"
                        data-testid="breadcrumbs"
                    >
                        {breadcrumbs.map((b, i) => (
                            <span key={i} className="flex items-center gap-2 text-[11px] uppercase tracking-[0.2em]">
                                {b.href ? (
                                    <Link to={b.href} className="text-white/40 hover:text-white transition-colors">
                                        {b.label}
                                    </Link>
                                ) : (
                                    <span className="text-white/65">{b.label}</span>
                                )}
                                {i < breadcrumbs.length - 1 && <CaretRight size={10} className="text-white/30" />}
                            </span>
                        ))}
                    </motion.div>
                )}

                {eyebrow && (
                    <motion.div
                        initial={{ opacity: 0, y: 8 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="eyebrow mb-4"
                    >
                        {eyebrow}
                    </motion.div>
                )}

                <motion.h1
                    initial={{ opacity: 0, y: 16 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.05 }}
                    className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.02] tracking-tight font-semibold"
                    data-testid="page-title"
                >
                    {title} {accent && <span className="gradient-text">{accent}</span>}
                </motion.h1>

                {intro && (
                    <motion.p
                        initial={{ opacity: 0, y: 12 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.15 }}
                        className="mt-5 max-w-2xl text-base text-white/60 leading-relaxed"
                        data-testid="page-intro"
                    >
                        {intro}
                    </motion.p>
                )}
            </div>
        </section>
    );
};
